import type { ApiClientCore } from './apiClient.core.js';
import type { ApiResponse } from './apiClient.types.js';

/** Tenant GET integration-governance (flags). Credential list/upsert/verify removed Wave 6 (platform env only). */
export const commsMethods = {
  async getTenantCommsIntegrationGovernance(this: ApiClientCore): Promise<
    ApiResponse<{
      tenantMayConfigureEmail: boolean;
      tenantMayConfigureReceipt: boolean;
      tenantMayConfigureSms: boolean;
    }>
  > {
    return this.get('/api/v1/admin/comms/integration-governance', false);
  },
};
